import React from 'react';

import { Banner as VKBanner, Button, } from '@vkontakte/vkui';

import styles from './index.module.css';
import { BannerProps } from './types';

export const Banner: React.FC<BannerProps> = ({ onAppWithTestsClick }) => {
  return (
    <div>
      <VKBanner
        mode="image"
        size="s"
        header="Узнать больше о профессиональном типе"
        className={styles.banner}
        subheader={(
          <span>
                Пройдите больше тестов
            <br />в нашем приложении
          </span>
        )}
        background={<div className={styles.bannerBackground} />}
        actions={(
          <Button appearance="overlay" size="m" onClick={onAppWithTestsClick}>
                Перейти
          </Button>
        )}
      />
    </div>
  );
};
